export const schoolsKey = "schools";
export const schoolClassesKey = "schoolClasses";
export const joinClassKey = "joinClass";
export const schoolParentConnectionsInfoKey = "schoolParentConnectionsInfo";
export const inviteSchoolParentsKey = "inviteSchoolParents";
export const inviteSchoolClassesParentsKey = "inviteSchoolClassesParents";
